// export const updateValue = ({ commit }, payload) => {
//     commit('updateValue', payload);
//   };

let action = {};

export default action;